<template>
  <div class="container">
    <p class="header"><span class="leftLine"></span>客户电力交易结算</p>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <el-form :inline="true"
                   :model="formInline"
                   class="demo-form-inline">
            <el-form-item label="客户名称：">
              <el-select v-model="formInline.customername"
                         filterable
                         clearable
                         placeholder="请选择">
                <el-option v-for="item in clientNames"
                           :key="item.clientId"
                           :label="item.clientName"
                           :value="item.clientName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域：">
              <el-select v-model="formInline.area"
                         filterable
                         clearable
                         placeholder="请选择区域">
                <el-option v-for="item in provinces"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期：">
              <el-date-picker v-model="formInline.balancedate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);">
          <el-row style="padding:20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                   style="margin-right:20px"></i>结算列表 单位：万千瓦时 、元</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <el-upload class="upload-demo"
                         action
                         :show-file-list="false"
                         v-if="show($store.state.menuList.khdljyjslist,'import')"
                         :http-request="uploadfile">
                <el-button size="small"
                           type="primary">导入</el-button>
              </el-upload>
                                       <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.khdljyjslist,'export')"
                     @click="exportMethod('https://c.cesc-energy.com/service/clientPowerDeal/export','电力交易结算.xlsx')">导出数据</el-button>
                     <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.khdljyjslist,'exportT')"
                     @click="exportMethod('https://c.cesc-energy.com/service/clientPowerDeal/export/template','电力交易结算.xlsx')">导出模板</el-button>
              <el-button type="primary"
                         style="margin-left:20px"
                         @click="add"
                         v-if="show($store.state.menuList.khdljyjslist,'add')"
                         size="mini">新增结算</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <el-table border
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange">
                <el-table-column type="selection">
                </el-table-column>
                <el-table-column prop="balancedate"
                                 sortable
                                 width="102"
                                 label="结算日期">
                </el-table-column>
                <el-table-column prop="customername"
                                 width="80"
                                 label="客户名称">
                </el-table-column>
                <el-table-column label="区域"
                                 width="60">
                  <template slot-scope="scope">{{ scope.row.areaName}}</template>
                </el-table-column>

                <el-table-column prop="electric"
                                 sortable
                                 width="102"
                                 label="交易电量(kW·h)">
                </el-table-column>
                <el-table-column prop="practical"
                                 sortable
                                 label="实际用电量(kW·h)">
                </el-table-column>
                <el-table-column prop="power"
                                 sortable
                                 width="102"
                                 label="偏差电量(kW·h)">
                </el-table-column>
                <el-table-column prop="deviationratio"
                                 width="90"
                                 label="偏差率(%)">
                </el-table-column>
                <el-table-column prop="bias"
                                 label="允许偏差电量(kWh)">
                </el-table-column>
                <el-table-column prop="assess"
                                 label="考核执行偏差">
                </el-table-column>
                <el-table-column prop="deviation"
                                 label="偏差考核费用">
                </el-table-column>
                <el-table-column prop="userfees"
                                 label="用户偏差考核费用">
                </el-table-column>
                <el-table-column prop="name"
                                 sortable
                                 label="代理售电公司考核费用">
                </el-table-column>
                <el-table-column prop="discount"
                                 width="80"
                                 label="优惠金额">
                </el-table-column>
                <el-table-column prop="totaldiscount"
                                 width="106"
                                 label="合计优惠金额">
                </el-table-column>
                <el-table-column prop="salesCommissions"
                                 width="106"
                                 label="销售提成">
                </el-table-column>
                <el-table-column prop="remake"
                                 label="备注">
                </el-table-column>
                <el-table-column prop="address"
                                 label="操作"
                                 width="140"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button @click="see(scope.row.id)"
                               type="text"
                               v-if="show($store.state.menuList.khdljyjslist,'see')"
                               size="small">查看</el-button>
                    <el-button @click="xg(scope.row.id)"
                               type="text"
                               v-if="show($store.state.menuList.khdljyjslist,'edit')"
                               size="small">修改</el-button>
                    <el-button type="text"
                               size="small"
                               v-if="show($store.state.menuList.khdljyjslist,'delete')"
                               @click="deleteTable(scope.$index, tableData,scope.row.id)">删除</el-button>

                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px"
                   v-if="show($store.state.menuList.khdljyjslist,'deletes')">
                <el-checkbox v-model="checked"
                             @change="toggleAllSelection"
                             style="margin-right:20px">全选</el-checkbox>
                <el-button @click="deleteTables"
                           type="danger">批量删除</el-button>
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getQueryDeal, deleteQueryDeal, getmenusubmenu, deletesQueryDeal, postQueryDealFile, getprovince, getclientNames } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      checked: false,
      total: 0,
      current: 1,
      multipleSelection: [],
      formInline: {},
      tableData: [],
      clientNames: [],
      provinces: []
    }
  },
  created () {
    getQueryDeal().then(res => {
      if (res.code == 0) {
        this.total = res.data.total;
        this.current = res.data.current;
        this.tableData = res.data.records
      }
    })
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
    getclientNames().then(res => {
      if (res.code === 0) {
        this.clientNames = res.data
      }
    })
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'khdljyjslist', data: res.data })
        }
      })
    },
  },
  methods: {
    show,
        exportMethod,

    uploadfile (item) {
      let fileObj = item.file
          let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postQueryDealFile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
      })
    },
    xg (id) {
      this.$router.push({ path: '/jyzx/khdljyjsxg', query: { text: '修改' } });
      localStorage.setItem('dljyid', id)
    },
    see (id) {
      this.$router.push({ path: '/jyzx/khdljyjsck'});
      localStorage.setItem('dljyid', id)
    },
    add () {
      this.$router.push({ path: '/jyzx/khdljyjsxg', query: { text: '修改' } });
      localStorage.removeItem('dljyid')
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteQueryDeal(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].id)
        }
        deletesQueryDeal(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.current = 1,
              getQueryDeal().then(res => {
                if (res.code == 0) {
                  this.total = res.data.total;
                  this.current = res.data.current;
                  this.tableData = res.data.records
                }
              })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleClick (row) {
      console.log(row);
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    check (row) {
      localStorage.setItem('dlsjs', JSON.stringify(row))
      this.$router.push({ path: '/jyzx/dlsjsglxg' })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.infoId) {
            putClientInfo(null2str(this.form)).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              }
            })
          }
          else {
            let params = JSON.parse(JSON.stringify(this.form))
            postAccountNumber(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    onSubmit () {
      let params = this.formInline
      params.current = this.current
      getQueryDeal(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
